export default __webpack_public_path__ + "static/media/cineonhub_change.fb764fd8.svg";